import {FwStatusBadge} from "../FwStatusBadge"
import {DeviceInfo} from "../../types/shadow"

interface DeviceInfoPanelProps {
	deviceInfo: DeviceInfo
}

export const DeviceInfoPanel = ({deviceInfo}: DeviceInfoPanelProps) => (
	<div className="mb-4 bg-gray-50 dark:bg-gray-700/50 p-3 rounded">
		<h4 className="font-medium text-gray-700 dark:text-gray-300 mb-2">Device Information:</h4>
		<div className="grid grid-cols-1 gap-2 text-sm">
			<div>
				<span className="text-gray-600 dark:text-gray-400">SW Version:</span>
				<span className="font-medium ml-2 text-gray-900 dark:text-gray-100">
					{deviceInfo.softwareVersion}
				</span>
			</div>
			<div className="flex items-center gap-2">
				<span className="text-gray-600 dark:text-gray-400">FW Status:</span>
				{deviceInfo.fwStatus !== "N/A" ? (
					<FwStatusBadge status={deviceInfo.fwStatus} />
				) : (
					<span className="font-medium text-gray-900 dark:text-gray-100">N/A</span>
				)}
			</div>
			<div>
				<span className="text-gray-600 dark:text-gray-400">Radar FW Versions:</span>
				{deviceInfo.radarVersions.length > 0 ? (
					<div className="mt-1 space-y-0.5">
						{deviceInfo.radarVersions.map((v, idx) => (
							<div
								key={idx}
								className={`text-xs font-semibold font-mono ${
									v.isLatest === null
										? "text-gray-400 dark:text-gray-400"
										: v.isLatest
											? "text-green-600 dark:text-green-400"
											: "text-orange-500 dark:text-orange-400"
								}`}>
								{v.text}
							</div>
						))}
					</div>
				) : (
					<span className="ml-2 font-medium text-gray-900 dark:text-gray-100">N/A</span>
				)}
			</div>
			<div className="flex items-center gap-2">
				<span className="text-gray-600 dark:text-gray-400">Radar FW Status:</span>
				{deviceInfo.radarFwStatus !== "N/A" ? (
					<FwStatusBadge status={deviceInfo.radarFwStatus} />
				) : (
					<span className="font-medium text-gray-900 dark:text-gray-100">N/A</span>
				)}
			</div>
		</div>
	</div>
)
